import { LengthUnits } from "@/libs/units/length";

const CUBIC_FEET_PER_BARREL = 5.614583;
const SECONDS_PER_DAY = 86400;
export const HPS_DISCHARGE_VELOCITY_LIMIT_FT_SEC = 20;

export function calculateCircularFlowVelocityFtSec(
  flowRateBBLD: number | null | undefined,
  innerDiameterInches: number | null | undefined
): number | null {
  if (!flowRateBBLD || !innerDiameterInches) return null;

  const flowFt3PerSec =
    (flowRateBBLD * CUBIC_FEET_PER_BARREL) / SECONDS_PER_DAY;
  const innerDiameterFt =
    LengthUnits.Inches.toStandardUnit(innerDiameterInches);
  const radiusFt = innerDiameterFt / 2;
  const areaFt2 = Math.PI * radiusFt * radiusFt;

  return areaFt2 > 0 ? flowFt3PerSec / areaFt2 : null;
}
